import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d940f594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-5 fs-6" }
const _hoisted_3 = { class: "bg-search p-4 rounded-3 mb-4" }
const _hoisted_4 = { class: "col-form-label fw-bold mb-2" }
const _hoisted_5 = { class: "rounded-3 bg-search px-3 py-1 mb-3" }
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "row m-1 m-lg-5" }
const _hoisted_8 = { class: "row mb-3 pb-4 border-bottom" }
const _hoisted_9 = { class: "col-lg-2 col-form-label" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = ["maxlength", "placeholder"]
const _hoisted_12 = { class: "row mb-3 pb-4 border-bottom" }
const _hoisted_13 = { class: "col-lg-2 col-form-label" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = ["maxlength", "placeholder"]
const _hoisted_16 = { class: "row mb-3 pb-4 border-bottom" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1))
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = ["for"]
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "d-flex justify-content-center mb-5" }
const _hoisted_23 = { class: "d-flex justify-content-end mb-3" }
const _hoisted_24 = { class: "d-lg-flex" }
const _hoisted_25 = { class: "d-flex align-items-center ms-3" }
const _hoisted_26 = { class: "cursor-pointer" }
const _hoisted_27 = { class: "d-flex fw-bold align-items-center fs-7" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["data-bs-target"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  "data-bs-Toggle": "modal",
  "data-bs-target": "#deleteRoom",
  class: "fas fa-trash-alt text-danger"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_35 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_36 = { class: "mt-3 d-flex" }
const _hoisted_37 = { class: "d-flex align-items-center ms-3" }

import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Loading from '@/components/loading/index.vue'
import ModalCreate from './components/ModalCreate.vue'
import EditTalkRoomModal from './components/EditTalkRoomModal.vue'
import ModalEditForUser from './components/ModalEditForUser.vue'
import DeleteTalkRoom from './components/DeleteTalkRoom.vue'
import Button from '@/components/button/index.vue'
import { ref, computed, onMounted, watch } from 'vue'
import { translate } from '@/languages/i18n'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Table from '@/components/table/index.vue'
import { GROUPS_STORE } from '@/store/constants'
import UserAliasIcon from '@/components/user-alias-icon'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { ReplayName } from '@/constants/common.ts'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import TotalRecords from '@/components/total-records/index.vue'
import { MAX_LENGTH_TALKROOM_NAME_SEARCH, MAX_LENGTH_CREATOR_SEARCH } from '@/constants/number'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const route = useRoute()
const router = useRouter()
const sortField = ref('')

const currentData = ref('')
const talkRoomName = ref('')

const data = computed(() => store.getters[GROUPS_STORE.GETTERS.LIST_TALK_ROOMS])
const detailGroup = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_GROUPS])

const loading = ref(false)
const ReplayNameMessage = (is_deleted_in_30_days: string | number, available: boolean, family_name: string, given_name: string) => {
  if (is_deleted_in_30_days === 0) {
    if (!available) {
      return family_name + ' ' + given_name + ' ' + '[一時停止]'
    } else return family_name + ' ' + given_name
  } else if (is_deleted_in_30_days === 1) {
    return family_name + ' ' + given_name + ' ' + '[脱退済み]'
  } else if (is_deleted_in_30_days === 2) {
    return '脱退済みユーザ'
  } else {
    return family_name + ' ' + given_name
  }
}

const dataSearchInput = ref({
  name: '',
  created_name: '',
  publishedDefault: '',
})
const dataSearch = ref({
  keyword_name: '',
  keyword_created_name: '',
  published: '',
})
const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('groupManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('listGroup'),
    to: `/${route.path.split('/')[1]}/communities/${route.params?.id}/admin/groups?created_at=asc`,
    active: false,
  },
  {
    content: translate('listTalkrooms'),
    to: '',
    active: true,
  },
]

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

onMounted(() => {
  const params = {
    create_by_admin: true,
  }
  store.dispatch(GROUPS_STORE.ACTIONS.SET_DETAIL_GROUPS, { group_id: route?.params?.group_id, params })
})
const count = ref<number>(0)
const setCurrentData = (id: any, name: string): void => {
  const data = {
    id,
    params: { create_by_admin: true },
  }
  store.dispatch(GROUPS_STORE.ACTIONS.SET_DETAIL_TALK_ROOM, data)

  currentData.value = id
  talkRoomName.value = name
  count.value++
}

watch(
  () => route.query,
  () => {
    dataSearch.value = {
      keyword_name: route.query?.keyword_name || '',
      keyword_created_name: route.query?.keyword_created_name || '',
      published: route.query?.published ? '' : true,
    }
    dataSearchInput.value = {
      name: route.query?.keyword_name || '',
      created_name: route.query?.keyword_created_name || '',
      publishedDefault: !route.query?.published ? '' : true,
    }
  },
  {
    immediate: true,
  }
)
watch(
  () => route.query,

  async () => {
    if (route.path === `/community/communities/${route.params?.id}/admin/groups/${route.params?.group_id}/talkrooms`) {
      loading.value = true
      await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_TALK_ROOMS, {
        id: route.params?.group_id,
        params: { ...route.query, ...dataSearch.value, page: route.query?.page || 1, page_of_number: route.query?.page_of_number || 30, create_by_admin: true },
      })
      loading.value = false
    }
  },
  {
    immediate: true,
  }
)
// 2022/09/15 CW-Phuong Fix for horizontal fixing#7: OD10
const SearchKey = async () => {
  if (checkRouter()) {
    if (route.path === `/community/communities/${route.params?.id}/admin/groups/${route.params?.group_id}/talkrooms`) {
      loading.value = true
      // 2022/09/28 CW-Phuong Fix for UAT Phase2#4490: OD10 (Ph2-R20220930)
      dataSearch.value = {
        keyword_name: route.query?.keyword_name || '',
        keyword_created_name: route.query?.keyword_created_name || '',
        published: route.query?.published ? '' : true,
      }
      await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_TALK_ROOMS, {
        id: route.params?.group_id,
        params: { ...route.query, ...dataSearch.value, page: route.query?.page || 1, page_of_number: route.query?.page_of_number || 30, create_by_admin: true },
      })
      loading.value = false
    }
  }
  dataSearch.value = {
    keyword_name: dataSearchInput.value.name,
    keyword_created_name: dataSearchInput.value.created_name,
    published: !dataSearchInput.value.publishedDefault ? '' : true,
  }
  router.push({ path: route.path, query: { ...route.query, ...dataSearch.value, page_of_number: route.query?.page_of_number || 30 } })
}
// 2022/09/15 CW-Phuong Fix for horizontal fixing#7: OD10
const checkRouter = () => {
  let keyword_name_route = route.query?.keyword_name ?? ''
  let keyword_created_name_route = route.query?.keyword_created_name ?? ''
  let published_route = ''
  if (route.query.published) published_route = true
  if (
    dataSearchInput.value.name === keyword_name_route &&
    dataSearchInput.value.created_name === keyword_created_name_route &&
    dataSearchInput.value.publishedDefault === published_route
  )
    return true
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('OD10listGroup')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)('groupName')) + " : " + _toDisplayString(_unref(detailGroup)?.name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)('search')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(SearchKey, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('talkRoomName')), 1),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: _unref(MAX_LENGTH_TALKROOM_NAME_SEARCH),
                  placeholder: _unref(translate)('placeholder'),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataSearchInput.value.name) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_11), [
                  [
                    _vModelText,
                    dataSearchInput.value.name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(translate)('creator')), 1),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: _unref(MAX_LENGTH_CREATOR_SEARCH),
                  placeholder: _unref(translate)('placeholder'),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataSearchInput.value.created_name) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_15), [
                  [
                    _vModelText,
                    dataSearchInput.value.created_name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: _ctx.flexCheckDefault
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataSearchInput.value.publishedDefault) = $event)),
                      id: _ctx.flexCheckDefault
                    }, null, 8, _hoisted_21), [
                      [_vModelCheckbox, dataSearchInput.value.publishedDefault]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('privateTalkrooms')), 1)
                  ], 8, _hoisted_20)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(Button, {
              title: _unref(translate)('searchButton'),
              type: 'secondary',
              htmlType: 'submit'
            }, null, 8, ["title"])
          ])
        ], 40, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(ModalCreate)
      ]),
      _createVNode(TotalRecords, {
        totalRecords: _unref(data)?.total_records
      }, null, 8, ["totalRecords"]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(Pagination, {
          totalDataOfPage: _unref(data)?.data?.length,
          totalPage: _unref(data)?.total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ]),
      _createVNode(Table, {
        columns: [
        { field: 'name', name: _unref(translate)('talkRoomName') },
        { field: 'created_mngt_no', name: _unref(translate)('managementNo'), sort: sortField.value === 'created_mngt_no' },
        { field: 'created_name', name: _unref(translate)('creator'), sort: sortField.value === 'created_name' },
        { field: 'created_at', name: _unref(translate)('registrationDate'), sort: sortField.value === 'created_at', defaultSort: 'desc' },
        { field: 'updated_at', name: _unref(translate)('lastUpdateTime'), sort: sortField.value === 'updated_at' },
        { field: 'edit', name: _unref(translate)('edit') },
        { field: 'delete', name: _unref(translate)('delete') },
      ],
        sortCells: ['created_mngt_no', 'created_name', 'created_at', 'updated_at']
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data)?.data, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: _normalizeClass(['align-middle text-center', index % 2 === 0 && 'rowEven', !item?.published && 'bg-private']),
              key: index
            }, [
              _createElementVNode("td", _hoisted_26, [
                _createVNode(_component_router_link, {
                  to: `/community/communities/${_unref(route).params?.id}/admin/groups/${_unref(route).params?.group_id}/talkrooms/${item.id}`,
                  class: "black-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item?.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, _toDisplayString(item?.admin?.management_no), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_unref(UserAliasIcon), {
                    userType: item?.admin?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(ReplayNameMessage(item?.admin?.is_deleted_in_30_days, item?.admin?.available, item?.admin?.family_name, item?.admin?.given_name)), 1),
                    (item?.admin?.user_type === 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "（" + _toDisplayString(item?.admin?.display_name) + "）", 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(_unref(ConvertFromLocalTime)(item?.created_at)), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(ConvertFromLocalTime)(item?.updated_at)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(['cursor-pointer']),
                  onClick: ($event: any) => (setCurrentData(item.id, item.name))
                }, [
                  _createElementVNode("i", {
                    "data-bs-Toggle": "modal",
                    "data-bs-target": Number(item?.admin?.user_type) === 3 ? '#editRoom' : '#editRoomUser',
                    class: "fas fa-pen color-edit"
                  }, null, 8, _hoisted_30)
                ], 8, _hoisted_29)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (setCurrentData(item.id, item.name))
                }, _hoisted_33, 8, _hoisted_31)
              ])
            ], 2))
          }), 128))
        ]),
        _: 1
      }, 8, ["columns"]),
      (_unref(data)?.data?.length === 0 && (dataSearch.value.keyword_name || dataSearch.value.keyword_created_name) && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(translate)('CC40noData')), 1))
        : _createCommentVNode("", true),
      (_unref(data)?.data?.length === 0 && !dataSearch.value.keyword_name && !dataSearch.value.keyword_created_name && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(translate)('OE65noData')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(Pagination, {
          totalDataOfPage: _unref(data)?.data?.length,
          totalPage: _unref(data)?.total_pages
        }, null, 8, ["totalDataOfPage", "totalPage"]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ])
    ]),
    _createVNode(EditTalkRoomModal, {
      talkRoomId: currentData.value,
      count: count.value
    }, null, 8, ["talkRoomId", "count"]),
    _createVNode(ModalEditForUser, {
      talkRoomId: currentData.value,
      count: count.value
    }, null, 8, ["talkRoomId", "count"]),
    _createVNode(DeleteTalkRoom, {
      talkRoomId: currentData.value,
      talkRoomName: talkRoomName.value
    }, null, 8, ["talkRoomId", "talkRoomName"]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})